import React from 'react';

export const Footer = ({ selectedNavitem }) => {
  return (
    <>

      <footer>
      </footer>

    </>
  );
};